import * as i0 from '@angular/core';
import { Injectable, Component, Input, ViewChild, NgModule } from '@angular/core';
import { HttpErrorResponse, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { Observable, BehaviorSubject, throwError, of } from 'rxjs';
import { catchError, switchMap, finalize, filter, take } from 'rxjs/operators';
import Swal from 'sweetalert2';
import * as i1 from '@nutricontrol/app360-shared';
import { AppCommonsModule, UserType } from '@nutricontrol/app360-shared';
import * as i7 from '@angular/common';
import { UpperCasePipe, NgForOf, NgIf } from '@angular/common';
import * as i5$1 from '@angular/forms';
import { FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import * as i3 from '@angular/material/form-field';
import * as i4 from '@angular/material/select';
import { MatSelectModule } from '@angular/material/select';
import * as i5 from '@angular/material/core';
import * as i4$1 from '@angular/material/table';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import * as i3$1 from '@angular/material/paginator';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatInputModule } from '@angular/material/input';
import * as i4$2 from 'angular-code-input';
import { CodeInputModule } from 'angular-code-input';
import * as i2 from '@angular/router';

class RestApiService {
    constructor(httpRepositoryService, session) {
        this.httpRepositoryService = httpRepositoryService;
        this.session = session;
    }
    getLegalAgreementsText() {
        return this.httpRepositoryService.getRequest('common/legal-agreements/latest-text');
    }
    getLegalAgreementsVersion() {
        return this.httpRepositoryService.getRequest('common/legal-agreements/latest-version');
    }
    getUserLegalAgreementsVersion(data) {
        return this.httpRepositoryService.getRequest('users/' + data + '/accepted-legal-agreements-version');
    }
    putUserLegalAgreementsVersion(vid, data) {
        return this.httpRepositoryService.putRequest('users/' + vid + '/accepted-legal-agreements-version', data);
    }
    getUserData() {
        return this.httpRepositoryService.getRequest('users/' + this.session.getSessionUserVid());
    }
    putUserData(data) {
        return this.httpRepositoryService.putRequest('users/' + this.session.getSessionUserVid(), data);
    }
    deleteUser(data) {
        return this.httpRepositoryService.postRequest('users/' + this.session.getSessionUserVid() + '/delete', data);
    }
    postRegister(data) {
        return this.httpRepositoryService.postRequest('users', data);
    }
    postRegisterPushToken(data) {
        return this.httpRepositoryService.postRequest('notifications/devices', data);
    }
    getNotificationPreferences() {
        return this.httpRepositoryService.getRequest('notifications/preferences');
    }
    putUserNotificationPreferences() {
        return this.httpRepositoryService.putRequest('notifications/preferences/user', {});
    }
    putUserDeviceNotificationPreferences(deviceId) {
        return this.httpRepositoryService.putRequest(`notifications/preferences/device/${deviceId}`, {});
    }
    putUserTerminalNotificationPreferences(terminalVid) {
        return this.httpRepositoryService.putRequest(`notifications/preferences/terminal/${terminalVid}`, {});
    }
    confirmCode(confirmationCode) {
        return this.httpRepositoryService.postRequest('v2/auth/' + confirmationCode.identifier + '/confirm', confirmationCode.data);
    }
    resendCode(identifier) {
        return this.httpRepositoryService.postRequest('v2/auth/' + identifier + '/resend-confirm', []);
    }
    resetPasswordEmail(data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + data.email + '/reset-password', {});
    }
    checkResetPassword(data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + data.email + '/check-reset-password', data);
    }
    confirm2fa(userVid, data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + userVid + '/confirm-2fa', data);
    }
    resend2fa(email) {
        return this.httpRepositoryService.postRequest('v2/auth/' + email + '/resend-2fa', {});
    }
    getCheckUserAuth() {
        return this.httpRepositoryService.getRequest('v2/auth/check');
    }
    login(data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + data.email + '/login', { password: data.password });
    }
    refreshToken(data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + data.user_vid + '/refresh-token', data);
    }
    postNewPassword(userVid, data) {
        return this.httpRepositoryService.postRequest('v2/auth/' + userVid + '/password', data);
    }
    getAuthConfig(userVid) {
        return this.httpRepositoryService.getRequest('v2/auth/' + userVid + '/config');
    }
    putAuthConfig(authConfig) {
        return this.httpRepositoryService.putRequest('v2/auth/' + authConfig.user_vid + '/config', authConfig);
    }
    getAuthLoginLogs(userVid) {
        return this.httpRepositoryService.getRequest('v2/auth/' + userVid + '/login-logs');
    }
    putNewPassword(data) {
        return this.httpRepositoryService.putRequest('v2/auth/' + this.session.getSessionUserVid() + '/password', data);
    }
    loginBackoffice(data) {
        return this.httpRepositoryService.postRequest('v2/backoffice-auth/auth/' + data.email + '/login', { password: data.password });
    }
    refreshBackofficeToken(data) {
        return this.httpRepositoryService.postRequest('v2/backoffice-auth/auth/' + data.user_vid + '/refresh-token', { token: data.token, access_token: data.access_token });
    }
    getImpersonateToken(email) {
        return this.httpRepositoryService.postRequest('v2/backoffice-auth/auth/' + email + '/impersonate', []);
    }
    resetUserInvitation(userVid) {
        return this.httpRepositoryService.postRequest('v2/backoffice-auth/auth/' + userVid + '/reset-invitation', null);
    }
}
RestApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, deps: [{ token: i1.HttpRepositoryService }, { token: i1.SessionLibService }], target: i0.ɵɵFactoryTarget.Injectable });
RestApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: RestApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpRepositoryService }, { type: i1.SessionLibService }]; } });

class App360AuthSharedService {
    constructor(restApiService, sessionLibService, usersLibService, platformLibService, environmentService) {
        this.restApiService = restApiService;
        this.sessionLibService = sessionLibService;
        this.usersLibService = usersLibService;
        this.platformLibService = platformLibService;
        this.environmentService = environmentService;
        this.legalAdviceTitle = '';
        this.legalAdviceText = '';
        this.cookiePolicyTitle = '';
        this.cookiePolicyText = '';
        this.privacyPolicyTitle = '';
        this.privacyPolicyText = '';
    }
    getLegalAgreementsText() {
        return this.restApiService.getLegalAgreementsText();
    }
    getLatestLegalAgreementsVersion() {
        return this.restApiService.getLegalAgreementsVersion();
    }
    getUserLatestLegalAgreements(data) {
        return this.restApiService.getUserLegalAgreementsVersion(data);
    }
    putUserLatestLegalAgreements(vid, data) {
        return this.restApiService.putUserLegalAgreementsVersion(vid, data);
    }
    getUserData() {
        return this.restApiService.getUserData();
    }
    createRegister(data) {
        return this.restApiService.postRegister(data);
    }
    confirmCode(confirmationCode) {
        return this.restApiService.confirmCode(confirmationCode);
    }
    resendCodeEmail(identifier) {
        return this.restApiService.resendCode(identifier);
    }
    resetPasswordEmail(data) {
        return this.restApiService.resetPasswordEmail(data);
    }
    checkResetPassword(data) {
        return this.restApiService.checkResetPassword(data);
    }
    confirm2fa(data) {
        return this.restApiService.confirm2fa(data.user_vid, data);
    }
    resend2fa(email) {
        return this.restApiService.resend2fa(email);
    }
    login(data) {
        return this.restApiService.login(data);
    }
    checkAuth() {
        return new Observable((observer) => {
            this.restApiService.getCheckUserAuth().subscribe((response) => {
                if (response.impersonated_token === true) {
                    this.sessionLibService.setImpersonated(true);
                }
                else {
                    this.sessionLibService.setImpersonated(false);
                    if (window.location.href.indexOf('localhost') < 0 &&
                        this.usersLibService.isBackoffice(response.user_identity.type) === true &&
                        window.location.href.indexOf('backoffice') < 0) {
                        const redirect_url = window.location.href.replace('app', 'backoffice');
                        // Avoid infinite redirects by destroying application session
                        this.sessionLibService.destroySession();
                        console.warn('[authService.checkAuth]: Logout + Redirect to BO!');
                        window.location.href = redirect_url;
                    }
                }
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
    refreshToken(data) {
        return new Observable((observer) => {
            this.restApiService.refreshToken(data).subscribe((response) => {
                if (response.user_identity) {
                    this.sessionLibService.createSession(response.user_identity.vid, response.user_identity.name, response.user_identity.email, response.session_vid, response.token, response.access_token, response.user_identity.type, response.user_identity.language);
                }
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
    postRegisterPushToken(data) {
        return this.restApiService.postRegisterPushToken(data);
    }
    getLegalAgreements() {
        this.getLegalAgreementsText().subscribe((response) => {
            this.legalAdviceTitle = response.legal_advice_title;
            this.legalAdviceText = response.legal_advice_text;
            this.cookiePolicyTitle = response.cookie_policy_title;
            this.cookiePolicyText = response.cookie_policy_text;
            this.privacyPolicyTitle = response.privacy_policy_title;
            this.privacyPolicyText = response.privacy_policy_text;
        });
    }
    checkUserLegalAgreementsVersion(userVid) {
        // Get latest
        this.getLatestLegalAgreementsVersion().subscribe((responseLatest) => {
            const legalVersion = responseLatest.latest_version;
            // Get user's accepted version
            this.getUserLatestLegalAgreements(userVid).subscribe((responseUserLatest) => {
                const userLegalVersion = responseUserLatest.accepted_legal_agreement_version;
                // Not accepted
                if (userLegalVersion < legalVersion) {
                    // Get text
                    this.getLegalAgreementsText().subscribe((response) => {
                        Swal.fire({
                            title: response.legal_advice_title,
                            text: response.legal_advice_text,
                            confirmButtonColor: '#224261',
                        }).then((result) => {
                            /* Read more about isConfirmed, isDenied below */
                            if (result.isConfirmed) {
                                this.putUserLatestLegalAgreements(this.sessionLibService.getSessionUserVid(), legalVersion).subscribe((legal) => { });
                            }
                        });
                    });
                }
            });
        });
    }
    doLogin(authResponse, callBackRedirect = false) {
        this.sessionLibService.createSession(authResponse.user_vid, authResponse.user_identity?.name, authResponse.user_identity?.email, authResponse.session_vid, authResponse.token, authResponse.access_token, authResponse.user_identity?.type, authResponse.user_identity?.language);
        this.environmentService.setLanguage(authResponse.user_identity?.language);
        const initialName = authResponse.user_identity?.name[0];
        const initialSurname = authResponse.user_identity?.surname[0];
        this.checkUserLegalAgreementsVersion(this.sessionLibService.getSessionUserVid());
        return new Observable((observer) => {
            this.restApiService.getUserData().subscribe((user) => {
                const avatar = {
                    name: (initialName + ' ' + initialSurname).trim(),
                    background: user.avatar_colors[0],
                    color: user.avatar_colors[1],
                };
                this.sessionLibService.setAvatar(avatar);
                if (callBackRedirect) {
                    if (this.platformLibService.isNative()) {
                        console.error('[LOGIN]: Native platform, go ahead');
                        this.postRegisterPushToken(JSON.parse(sessionStorage.getItem('notifications_data'))).subscribe(() => {
                            // eslint-disable-next-line no-console
                            console.info('[LOGIN]: Registration push token: ', sessionStorage.getItem('notifications_data'));
                            this.redirectToNextPostAction(authResponse);
                            observer.next(true);
                        }, (error) => {
                            console.error('[LOGIN]: Error', error);
                            this.redirectToNextPostAction(authResponse);
                            observer.next(false);
                        });
                    }
                    else {
                        console.error('[LOGIN]: Web platform, go ahead');
                        this.redirectToNextPostAction(authResponse);
                        observer.next(true);
                    }
                }
                else {
                    observer.next(true);
                }
            }, (error) => {
                console.warn('doLogin: user is not ready yet!');
                observer.error(false);
            });
        });
    }
    createNewPassword(userVid, data) {
        return this.restApiService.postNewPassword(userVid, data);
    }
    redirectToNextPostAction(authResponse) {
        console.log('[AuthService]: redirectToNextPostAction', authResponse);
        const home = String(this.sessionLibService.getHome());
        switch (authResponse.next_action) {
            case 'auth_success_redirect_to_home':
                if (window.location.href.indexOf(home) < 0) {
                    console.log('[AuthService]: redirectToNextPostAction.auth_success_redirect_to_home redirect');
                    location.replace(home);
                }
                else {
                    console.log('[AuthService]: redirectToNextPostAction.auth_success_redirect_to_home no_action');
                }
                break;
            case 'auth_expired_redirect_to_login':
                this.sessionLibService.destroySession(); // Be sure that session is fully destroyed!
                if (window.location.href.indexOf('/login') < 0) {
                    console.log('[AuthService]: redirectToNextPostAction.auth_expired_redirect_to_login redirect');
                    window.location.href = '/login';
                }
                else {
                    console.log('[AuthService]: redirectToNextPostAction.auth_expired_redirect_to_login no_action');
                }
                break;
            default:
                if (authResponse.token !== null && authResponse.access_token !== null) {
                    console.log('[AuthService]: redirectToNextPostAction.default redirect');
                    location.replace(home);
                }
                else {
                    console.log('[AuthService]: redirectToNextPostAction.default no_action');
                }
                break;
        }
        console.log('[AuthService]: redirectToNextPostAction.action_finished!');
    }
    putUsersData(data) {
        return this.restApiService.putUserData(data);
    }
    postDeleteUser(data) {
        return this.restApiService.deleteUser(data);
    }
    getAuthConfig(userVid) {
        return this.restApiService.getAuthConfig(userVid);
    }
    putAuthConfig(authConfig) {
        return this.restApiService.putAuthConfig(authConfig);
    }
    getAuthLoginLogs(userVid) {
        return this.restApiService.getAuthLoginLogs(userVid);
    }
    putNewPassword(data) {
        return this.restApiService.putNewPassword(data);
    }
    loginBackoffice(data) {
        return this.restApiService.loginBackoffice(data);
    }
    refreshBackofficeToken(data) {
        return new Observable((observer) => {
            this.restApiService.refreshBackofficeToken(data).subscribe((response) => {
                if (response.user_identity) {
                    this.sessionLibService.createSession(response.user_identity.vid, response.user_identity.name, response.user_identity.email, response.session_vid, response.token, response.access_token, response.user_identity.type, response.user_identity.language);
                }
                observer.next(response);
            }, (error) => {
                observer.error(error);
            });
        });
    }
    getImpersonateToken(email) {
        return this.restApiService.getImpersonateToken(email);
    }
    resetUserInvitation(userVid) {
        return this.restApiService.resetUserInvitation(userVid);
    }
    getNotificationPreferences() {
        return this.restApiService.getNotificationPreferences();
    }
    putUserNotificationPreferences() {
        return this.restApiService.putUserNotificationPreferences();
    }
    putUserDeviceNotificationPreferences(deviceId) {
        return this.restApiService.putUserDeviceNotificationPreferences(deviceId);
    }
    putUserTerminalNotificationPreferences(terminalVid) {
        return this.restApiService.putUserTerminalNotificationPreferences(terminalVid);
    }
}
App360AuthSharedService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedService, deps: [{ token: RestApiService }, { token: i1.SessionLibService }, { token: i1.UsersLibService }, { token: i1.PlatformLibService }, { token: i1.EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
App360AuthSharedService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: RestApiService }, { type: i1.SessionLibService }, { type: i1.UsersLibService }, { type: i1.PlatformLibService }, { type: i1.EnvironmentService }]; } });

class JwtInterceptor {
    constructor(platformLib, apiService, sessionLib, translationsLib, environmentService) {
        this.platformLib = platformLib;
        this.apiService = apiService;
        this.sessionLib = sessionLib;
        this.translationsLib = translationsLib;
        this.environmentService = environmentService;
        // Used for queued API calls while refreshing tokens
        this.tokenSubject = new BehaviorSubject(null);
        this.isRefreshingToken = false;
    }
    // Intercept every HTTP call
    intercept(request, next) {
        // Check if we need additional token logic or not
        if (this.isInBlockedList(request.url)) {
            return next.handle(request);
        }
        return next.handle(this.addToken(request)).pipe(catchError((err) => {
            if (err instanceof HttpErrorResponse) {
                // Returned by backend
                const errMessage = this.getErrorMessage(err);
                // Handle error!
                switch (err.status) {
                    case 400:
                        console.error('[UCROP-Interceptor]: Handle 400 error', err);
                        return this.handle400Error(err);
                    case 401:
                        if (errMessage.indexOf('[THROW IT]') >= 0) {
                            console.error('[UCROP-Interceptor]: Handle 401 error -> throw it!', err, err.url.indexOf('/auth/'), err.url.indexOf('/refresh-token'));
                            if (err.url.indexOf('/auth/') >= 0 &&
                                err.url.indexOf('/refresh-token') >= 0) {
                                console.error('[UCROP-Interceptor]: Refreshing token failed. Emergency exit to login screen!', err);
                                this.sessionExpiredForceToLoginScreen(null);
                            }
                            return throwError(err);
                        }
                        else {
                            console.error('[UCROP-Interceptor]: Handle 401 error -> handle as 403 error!', errMessage, err);
                            return this.handle403Error(request, next, errMessage);
                        }
                    case 403:
                        console.error('[UCROP-Interceptor]: Handle 403 error', errMessage, err);
                        return this.handle403Error(request, next, errMessage);
                    case 429:
                        console.error('[UCROP-Interceptor]: Handle 429 throttling error', errMessage, err);
                        Swal.fire({
                            text: this.translationsLib.get('throttling_error'),
                            icon: 'error',
                            confirmButtonColor: '#224261'
                        });
                        return throwError('throttling_error');
                    default:
                        console.error('[UCROP-Interceptor]: Handle default error', errMessage, err);
                        return throwError(err);
                }
            }
            else {
                console.error('[UCROP-Interceptor]: NonHttpErrorResponse Instance', err);
                return throwError(err);
            }
        }));
    }
    // Filter out URLs where you don't want to add the token!
    isInBlockedList(url) {
        // Example: Filter out our login and logout API call
        return url === `${this.environmentService.getBackend()}/auth`;
    }
    // Add our current access token from the service if present
    addToken(req) {
        const sessionToken = this.sessionLib.getSessionToken();
        if (!sessionToken) {
            window.console.info('[UCROP-Interceptor]: addToken Else');
            return req;
        }
        return req.clone({
            headers: new HttpHeaders({
                'api-key': `${this.sessionLib.getSessionToken()}`,
                'Content-Type': 'application/json',
                Accept: 'application/json',
                language: this.sessionLib.getLanguage(),
                'User-Platform': this.platformLib.choosePlatform(),
                'User-Platform-Native': this.platformLib.isNative().toString()
            })
        });
    }
    handle400Error(err) {
        // Potentially check the exact error reason for the 400
        // then log out the user automatically
        alert('Logged out due to authentication mismatch');
        this.sessionLib.destroySession();
        return of(null);
    }
    // Indicates our access token is invalid, try to load a new one
    handle403Error(request, next, err_message) {
        // Check if another call is already using the refresh logic
        window.console.info('[UCROP-Interceptor-handle403Error]: Init: ' + err_message);
        // err_message is returned by the backend
        if (err_message.indexOf('Access denied') >= 0 && !this.isRefreshingToken) {
            // Set to null so other requests will wait
            // until we got a new token!
            this.tokenSubject.next(null);
            this.isRefreshingToken = true;
            this.token = {
                session_vid: this.sessionLib.getSessionSessionVid(),
                user_vid: this.sessionLib.getSessionUserVid(),
                token: this.sessionLib.getSessionToken(),
                access_token: this.sessionLib.getAccessToken()
            };
            window.console.info('[UCROP-Interceptor-handle403Error]: Refresh Token', this.token);
            // First, get a new access token
            return this.apiService.refreshToken(this.token).pipe(switchMap((authResponse) => {
                window.console.info('[UCROP-Interceptor-handle403Error]: authResponse', authResponse);
                if (authResponse) {
                    if (authResponse.token !== null &&
                        authResponse.access_token !== null) {
                        if (authResponse.user_identity) {
                            window.console.info('[UCROP-Interceptor-handle403Error]: Update Session + Force Window Reload. This should happen once when reloading for first time!');
                            this.sessionLib.createSession(authResponse.user_identity.vid, authResponse.user_identity.name, authResponse.user_identity.email, authResponse.session_vid, authResponse.token, authResponse.access_token, authResponse.user_identity.type, authResponse.user_identity.language);
                            window.console.info('[UCROP-Interceptor-handle403Error]: Create session done');
                        }
                        this.sessionLib.updateSessionToken(authResponse.token);
                        this.sessionLib.updateSessionSessionVid(authResponse.session_vid);
                        window.location.reload();
                    }
                    else {
                        this.sessionExpiredForceToLoginScreen(authResponse);
                        setTimeout(() => {
                            window.console.info('[UCROP-Interceptor-handle403Error]: This should not happen');
                            window.location.href = '/';
                        }, 10000);
                    }
                }
                else {
                    this.sessionExpiredForceToLoginScreen(authResponse);
                    // No new token or other problem occurred
                    return of(null);
                }
            }, (error) => {
                setTimeout(() => {
                    const currentPath = window.location.pathname;
                    if (currentPath !== '/' && currentPath !== '/login') {
                        window.console.info('[UCROP-Interceptor-handle403Error]: Refresh Token Error, destroy session #1', error);
                        this.sessionLib.destroySession();
                        window.location.href = '/';
                    }
                    else {
                        window.console.info('[UCROP-Interceptor-handle403Error]: Refresh Token Error, do not destroy session #2', error);
                    }
                }, 1000);
            }), finalize(() => {
                // Unblock the token reload logic when everything is done
                window.console.info('[UCROP-Interceptor-handle403Error]: Finalize');
                this.isRefreshingToken = false;
            }));
        }
        else {
            window.console.info('[UCROP-Interceptor-handle403Error]: Else');
            // "Queue" other calls while we load a new token
            return this.tokenSubject.pipe(filter((token) => token !== null), take(1), switchMap((token) => {
                // Perform the request again now that we got a new token!
                window.console.info('[UCROP-Interceptor-handle403Error]: addToken', request);
                return next.handle(this.addToken(request));
            }));
        }
    }
    sessionExpiredForceToLoginScreen(authResponse) {
        this.sessionLib.destroySession();
        window.console.info('[UCROP-Interceptor-handle403Error]: Session destroyed');
        setTimeout(() => {
            if (authResponse?.next_action === 'auth_expired_redirect_to_login') {
                window.console.info('[UCROP-Interceptor-handle403Error]: Token Next Action auth_success_redirect_to_home');
            }
            else {
                window.console.info('[UCROP-Interceptor-handle403Error]: No next action');
            }
            const currentPath = window.location.pathname;
            if (currentPath !== '/' && currentPath !== '/login') {
                window.console.info('[UCROP-Interceptor-handle403Error]: Redirect to index page', currentPath);
                window.location.href = '/login';
            }
        }, 1000);
    }
    getErrorMessage(err) {
        let message = '';
        if ('message' in err) {
            message = err.message;
        }
        if (err.error) {
            if (typeof err.error === 'string') {
                message = err.error;
            }
            else if (err.error.error && typeof err.error.error === 'string') {
                message = err.error.error;
            }
        }
        return message;
    }
}
JwtInterceptor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JwtInterceptor, deps: [{ token: i1.PlatformLibService }, { token: App360AuthSharedService }, { token: i1.SessionLibService }, { token: i1.TranslationsLibService }, { token: i1.EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable });
JwtInterceptor.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JwtInterceptor });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: JwtInterceptor, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: i1.PlatformLibService }, { type: App360AuthSharedService }, { type: i1.SessionLibService }, { type: i1.TranslationsLibService }, { type: i1.EnvironmentService }]; } });

class Auth2faComponent {
    constructor(translationsLib, app360AuthSharedService) {
        this.translationsLib = translationsLib;
        this.app360AuthSharedService = app360AuthSharedService;
        this.ready = false;
        this.fb = new FormBuilder();
        this.selectedAuth2faType = '';
        this.selectedAuth2faUserPreference = '';
        this.auth2faTypes = ['auth_user_email'];
        this.auth2faUserPreferences = ['disabled', 'on_new_login', 'always'];
        this.auth2faForm = this.fb.group({
            auth_2fa_type: ['', Validators.required],
            auth_2fa_user_preference: ['', Validators.required],
        });
    }
    ngOnInit() {
        this.loadAuthConfig();
    }
    loadAuthConfig() {
        this.ready = false;
        this.app360AuthSharedService.getAuthConfig(this.userVid).subscribe((authConfig) => {
            this.selectedAuth2faType = authConfig.auth_2fa_type;
            this.selectedAuth2faUserPreference = authConfig.auth_2fa_user_preference;
            this.ready = true;
        });
    }
    onSubmit() {
        this.app360AuthSharedService
            .putAuthConfig({
            user_vid: this.userVid,
            auth_2fa_type: this.selectedAuth2faType,
            auth_2fa_user_preference: this.selectedAuth2faUserPreference,
        })
            .subscribe((authConfig) => {
            Swal.fire({
                text: this.translationsLib.get('save_changes_success'),
                showConfirmButton: true,
                confirmButtonText: this.translationsLib.get('accept'),
                icon: 'success',
            }).then(() => {
                this.loadAuthConfig();
            });
        }, (result) => {
            Swal.fire({
                icon: 'error',
                title: this.translationsLib.get('error'),
                text: this.translationsLib.get('fill_in_all_inputs_alert'),
                confirmButtonColor: '#224261',
            });
        });
    }
}
Auth2faComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: Auth2faComponent, deps: [{ token: i1.TranslationsLibService }, { token: App360AuthSharedService }], target: i0.ɵɵFactoryTarget.Component });
Auth2faComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: Auth2faComponent, selector: "lib-auth-2fa", inputs: { userVid: "userVid" }, ngImport: i0, template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\n<div class=\"card\" *ngIf=\"ready === true\">\n  <div class=\"card-header\">\n    <h2 class=\"text-header-primary m-0\">\n      {{ 'auth_2fa' | translation }}\n    </h2>\n  </div>\n  <div class=\"card-body\">\n    <div class=\"row\">\n      <div class=\"col-12 mb-2\" [innerHTML]=\"'auth_2fa_what_is' | translation\"></div>\n      <div class=\"col-12\">\n        <form novalidate [formGroup]=\"auth2faForm\" (submit)=\"onSubmit()\">\n          <div class=\"row\">\n            <div class=\"col-12 col-lg-5\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-block\">\n                  <span>{{ 'auth_2fa_user_preference_behaviour' | translation }}</span>\n                </label>\n                <mat-form-field appearance=\"fill\" class=\"w-100\">\n                  <mat-select id=\"auth_2fa_user_preference\" [(value)]=\"selectedAuth2faUserPreference\">\n                    <mat-option *ngFor=\"let auth2faUserPreference of auth2faUserPreferences\" [value]=auth2faUserPreference>\n                      {{ 'auth_2fa_user_preferences_' + auth2faUserPreference | translation }}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n              </div>\n            </div>\n            <div class=\"col-12 col-lg-5\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-block\">\n                  <span>{{ 'auth_2fa_user_type_device_used' | translation }}</span>\n                </label>\n                <mat-form-field appearance=\"fill\" class=\"w-100\">\n                  <mat-select id=\"auth_2fa_type\" [(value)]=\"selectedAuth2faType\">\n                    <mat-option *ngFor=\"let auth2faType of auth2faTypes\" [value]=auth2faType>\n                      {{ 'auth_2fa_types_' + auth2faType | translation }}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n              </div>\n            </div>\n            <div class=\"col-12 col-lg-2 text-end\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-none d-lg-block\">\n                  <span>&nbsp;</span>\n                </label>\n                <button type=\"button\"  class=\"btn btn-primary\" (click)=\"onSubmit();\">\n                  {{ 'save' | translation }}\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-12 mb-2 text-muted\" [innerHTML]=\"'auth_2fa_what_is_advanced' | translation\"></div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".form-label{font-weight:500;font-size:15px;color:#444}.form-label small{float:right;font-style:italic;font-size:12px;color:#224261}\n"], dependencies: [{ kind: "component", type: i1.LoaderComponent, selector: "lib-loader" }, { kind: "component", type: i3.MatFormField, selector: "mat-form-field", inputs: ["color", "appearance", "hideRequiredMarker", "hintLabel", "floatLabel"], exportAs: ["matFormField"] }, { kind: "component", type: i4.MatSelect, selector: "mat-select", inputs: ["disabled", "disableRipple", "tabIndex"], exportAs: ["matSelect"] }, { kind: "component", type: i5.MatOption, selector: "mat-option", exportAs: ["matOption"] }, { kind: "directive", type: i5$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i7.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.TranslationPipe, name: "translation" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: Auth2faComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-auth-2fa', template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\n<div class=\"card\" *ngIf=\"ready === true\">\n  <div class=\"card-header\">\n    <h2 class=\"text-header-primary m-0\">\n      {{ 'auth_2fa' | translation }}\n    </h2>\n  </div>\n  <div class=\"card-body\">\n    <div class=\"row\">\n      <div class=\"col-12 mb-2\" [innerHTML]=\"'auth_2fa_what_is' | translation\"></div>\n      <div class=\"col-12\">\n        <form novalidate [formGroup]=\"auth2faForm\" (submit)=\"onSubmit()\">\n          <div class=\"row\">\n            <div class=\"col-12 col-lg-5\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-block\">\n                  <span>{{ 'auth_2fa_user_preference_behaviour' | translation }}</span>\n                </label>\n                <mat-form-field appearance=\"fill\" class=\"w-100\">\n                  <mat-select id=\"auth_2fa_user_preference\" [(value)]=\"selectedAuth2faUserPreference\">\n                    <mat-option *ngFor=\"let auth2faUserPreference of auth2faUserPreferences\" [value]=auth2faUserPreference>\n                      {{ 'auth_2fa_user_preferences_' + auth2faUserPreference | translation }}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n              </div>\n            </div>\n            <div class=\"col-12 col-lg-5\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-block\">\n                  <span>{{ 'auth_2fa_user_type_device_used' | translation }}</span>\n                </label>\n                <mat-form-field appearance=\"fill\" class=\"w-100\">\n                  <mat-select id=\"auth_2fa_type\" [(value)]=\"selectedAuth2faType\">\n                    <mat-option *ngFor=\"let auth2faType of auth2faTypes\" [value]=auth2faType>\n                      {{ 'auth_2fa_types_' + auth2faType | translation }}\n                    </mat-option>\n                  </mat-select>\n                </mat-form-field>\n              </div>\n            </div>\n            <div class=\"col-12 col-lg-2 text-end\">\n              <div class=\"form-group\">\n                <label class=\"form-label d-none d-lg-block\">\n                  <span>&nbsp;</span>\n                </label>\n                <button type=\"button\"  class=\"btn btn-primary\" (click)=\"onSubmit();\">\n                  {{ 'save' | translation }}\n                </button>\n              </div>\n            </div>\n          </div>\n          <div class=\"col-12 mb-2 text-muted\" [innerHTML]=\"'auth_2fa_what_is_advanced' | translation\"></div>\n        </form>\n      </div>\n    </div>\n  </div>\n</div>\n", styles: [".form-label{font-weight:500;font-size:15px;color:#444}.form-label small{float:right;font-style:italic;font-size:12px;color:#224261}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationsLibService }, { type: App360AuthSharedService }]; }, propDecorators: { userVid: [{
                type: Input
            }] } });

class AuthLoginLogComponent {
    constructor(translationsLib, sessionLib, app360AuthSharedService) {
        this.translationsLib = translationsLib;
        this.sessionLib = sessionLib;
        this.app360AuthSharedService = app360AuthSharedService;
        this.ready = false;
        this.displayedColumns = [
            'auth_2fa_type',
            'auth_2fa_user_preference',
            'ip',
            'country_code',
            'region',
            'city',
            'platform',
            'browser',
            'first_session_at',
            'last_session_at',
        ];
        this.dataSource = new MatTableDataSource([]);
        this.totalItems = 0;
        this.pageSize = 0;
        this.currentPage = 0;
    }
    ngOnInit() {
        this.loadAuthLoginLogs();
    }
    loadAuthLoginLogs() {
        this.ready = false;
        this.app360AuthSharedService
            .getAuthLoginLogs(this.userVid)
            .subscribe((authLoginLogs) => {
            this.dataSource.data = authLoginLogs.items;
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.totalItems = authLoginLogs.total;
            this.pageSize = authLoginLogs.page_items_number;
            this.currentPage = authLoginLogs.current_page;
            this.ready = true;
        });
    }
    onPageChange(event) {
        this.currentPage = event.pageIndex;
        this.pageSize = event.pageSize;
        this.loadAuthLoginLogs();
    }
}
AuthLoginLogComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthLoginLogComponent, deps: [{ token: i1.TranslationsLibService }, { token: i1.SessionLibService }, { token: App360AuthSharedService }], target: i0.ɵɵFactoryTarget.Component });
AuthLoginLogComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AuthLoginLogComponent, selector: "lib-auth-login-log", inputs: { userVid: "userVid" }, viewQueries: [{ propertyName: "paginator", first: true, predicate: MatPaginator, descendants: true }, { propertyName: "sort", first: true, predicate: MatSort, descendants: true }], ngImport: i0, template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\n<div class=\"card\" *ngIf=\"ready === true\">\n  <div class=\"card-header\">\n    <h2 class=\"text-header-primary m-0\">\n      {{ 'auth_2fa_login_log' | translation }}\n    </h2>\n  </div>\n  <div class=\"card-body\">\n    <div class=\"row\">\n      <div class=\"col-12\">\n\n        <div class=\"mat-elevation-z8 overflow-scroll\">\n          <table mat-table [dataSource]=\"dataSource\" class=\"mat-table w-100\">\n\n            <ng-container matColumnDef=\"auth_2fa_type\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_user_type_device_used' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\">\n                <ng-container *ngIf=\"element.auth_2fa_user_preference === 'disabled'\">\n                  -\n                </ng-container>\n                <ng-container *ngIf=\"element.auth_2fa_user_preference !== 'disabled'\">\n                  {{ 'auth_2fa_types_' + element.auth_2fa_type | translation }}\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"auth_2fa_user_preference\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_user_preference_behaviour' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\">\n                {{ 'auth_2fa_user_preferences_' + element.auth_2fa_user_preference | translation }}\n              </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"ip\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> IP </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.ip }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"country_code\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef>{{ 'profile_account_country' | translation }}</th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.country_code | uppercase }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"region\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef>{{ 'profile_account_province' | translation }}</th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.region }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"city\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'profile_account_city' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.city }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"platform\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'operative_system' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.platform }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"browser\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'browser' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.browser }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"first_session_at\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_first_session_at' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\"> {{ element.first_session_at }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"last_session_at\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_last_session_at' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.last_session_at }} </td>\n            </ng-container>\n\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n          </table>\n\n          <mat-paginator\n            [length]=\"totalItems\"\n            [pageSize]=\"pageSize\"\n            [pageSizeOptions]=\"[20]\"\n            showFirstLastButtons\n            (page)=\"onPageChange($event)\">\n          </mat-paginator>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n", styles: ["td{padding-left:1rem!important;padding-right:1rem!important}\n"], dependencies: [{ kind: "component", type: i1.LoaderComponent, selector: "lib-loader" }, { kind: "component", type: i3$1.MatPaginator, selector: "mat-paginator", inputs: ["disabled"], exportAs: ["matPaginator"] }, { kind: "component", type: i4$1.MatTable, selector: "mat-table, table[mat-table]", exportAs: ["matTable"] }, { kind: "directive", type: i4$1.MatHeaderCellDef, selector: "[matHeaderCellDef]" }, { kind: "directive", type: i4$1.MatHeaderRowDef, selector: "[matHeaderRowDef]", inputs: ["matHeaderRowDef", "matHeaderRowDefSticky"] }, { kind: "directive", type: i4$1.MatColumnDef, selector: "[matColumnDef]", inputs: ["sticky", "matColumnDef"] }, { kind: "directive", type: i4$1.MatCellDef, selector: "[matCellDef]" }, { kind: "directive", type: i4$1.MatRowDef, selector: "[matRowDef]", inputs: ["matRowDefColumns", "matRowDefWhen"] }, { kind: "directive", type: i4$1.MatHeaderCell, selector: "mat-header-cell, th[mat-header-cell]" }, { kind: "directive", type: i4$1.MatCell, selector: "mat-cell, td[mat-cell]" }, { kind: "component", type: i4$1.MatHeaderRow, selector: "mat-header-row, tr[mat-header-row]", exportAs: ["matHeaderRow"] }, { kind: "component", type: i4$1.MatRow, selector: "mat-row, tr[mat-row]", exportAs: ["matRow"] }, { kind: "directive", type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.TranslationPipe, name: "translation" }, { kind: "pipe", type: i7.UpperCasePipe, name: "uppercase" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthLoginLogComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-auth-login-log', template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\n<div class=\"card\" *ngIf=\"ready === true\">\n  <div class=\"card-header\">\n    <h2 class=\"text-header-primary m-0\">\n      {{ 'auth_2fa_login_log' | translation }}\n    </h2>\n  </div>\n  <div class=\"card-body\">\n    <div class=\"row\">\n      <div class=\"col-12\">\n\n        <div class=\"mat-elevation-z8 overflow-scroll\">\n          <table mat-table [dataSource]=\"dataSource\" class=\"mat-table w-100\">\n\n            <ng-container matColumnDef=\"auth_2fa_type\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_user_type_device_used' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\">\n                <ng-container *ngIf=\"element.auth_2fa_user_preference === 'disabled'\">\n                  -\n                </ng-container>\n                <ng-container *ngIf=\"element.auth_2fa_user_preference !== 'disabled'\">\n                  {{ 'auth_2fa_types_' + element.auth_2fa_type | translation }}\n                </ng-container>\n              </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"auth_2fa_user_preference\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_user_preference_behaviour' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\">\n                {{ 'auth_2fa_user_preferences_' + element.auth_2fa_user_preference | translation }}\n              </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"ip\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> IP </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.ip }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"country_code\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef>{{ 'profile_account_country' | translation }}</th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.country_code | uppercase }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"region\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef>{{ 'profile_account_province' | translation }}</th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.region }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"city\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'profile_account_city' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.city }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"platform\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'operative_system' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.platform }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"browser\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'browser' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.browser }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"first_session_at\">\n              <th class=\"d-none d-lg-table-cell text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_first_session_at' | translation }} </th>\n              <td class=\"d-none d-lg-table-cell text-center\" mat-cell *matCellDef=\"let element\"> {{ element.first_session_at }} </td>\n            </ng-container>\n\n            <ng-container matColumnDef=\"last_session_at\">\n              <th class=\"text-center\" mat-header-cell *matHeaderCellDef> {{ 'auth_2fa_last_session_at' | translation }} </th>\n              <td class=\"text-center\" mat-cell *matCellDef=\"let element\"> {{ element.last_session_at }} </td>\n            </ng-container>\n\n            <tr mat-header-row *matHeaderRowDef=\"displayedColumns\"></tr>\n            <tr mat-row *matRowDef=\"let row; columns: displayedColumns;\"></tr>\n          </table>\n\n          <mat-paginator\n            [length]=\"totalItems\"\n            [pageSize]=\"pageSize\"\n            [pageSizeOptions]=\"[20]\"\n            showFirstLastButtons\n            (page)=\"onPageChange($event)\">\n          </mat-paginator>\n        </div>\n\n      </div>\n    </div>\n  </div>\n</div>\n", styles: ["td{padding-left:1rem!important;padding-right:1rem!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationsLibService }, { type: i1.SessionLibService }, { type: App360AuthSharedService }]; }, propDecorators: { userVid: [{
                type: Input
            }], paginator: [{
                type: ViewChild,
                args: [MatPaginator]
            }], sort: [{
                type: ViewChild,
                args: [MatSort]
            }] } });

class AuthConfigComponent {
    constructor(translationsLib, sessionLib) {
        this.translationsLib = translationsLib;
        this.sessionLib = sessionLib;
        this.show2faConfig = true;
        this.show2faLog = true;
    }
    ngOnInit() {
        this.userVid = this.sessionLib.getSessionUserVid();
    }
}
AuthConfigComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthConfigComponent, deps: [{ token: i1.TranslationsLibService }, { token: i1.SessionLibService }], target: i0.ɵɵFactoryTarget.Component });
AuthConfigComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: AuthConfigComponent, selector: "lib-auth-config", inputs: { show2faConfig: "show2faConfig", show2faLog: "show2faLog" }, ngImport: i0, template: "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <ng-container *ngIf=\"show2faConfig === true\">\r\n      <section>\r\n        <lib-auth-2fa [userVid]=\"this.userVid\"></lib-auth-2fa>\r\n      </section>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"show2faConfig === true && show2faLog === true\">\r\n      <hr class=\"my-5\">\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"show2faLog === true\">\r\n      <section>\r\n        <lib-auth-login-log [userVid]=\"this.userVid\"></lib-auth-login-log>\r\n      </section>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n", styles: [""], dependencies: [{ kind: "directive", type: i7.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: Auth2faComponent, selector: "lib-auth-2fa", inputs: ["userVid"] }, { kind: "component", type: AuthLoginLogComponent, selector: "lib-auth-login-log", inputs: ["userVid"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: AuthConfigComponent, decorators: [{
            type: Component,
            args: [{ selector: "lib-auth-config", template: "<div class=\"row\">\r\n  <div class=\"col-12\">\r\n    <ng-container *ngIf=\"show2faConfig === true\">\r\n      <section>\r\n        <lib-auth-2fa [userVid]=\"this.userVid\"></lib-auth-2fa>\r\n      </section>\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"show2faConfig === true && show2faLog === true\">\r\n      <hr class=\"my-5\">\r\n    </ng-container>\r\n\r\n    <ng-container *ngIf=\"show2faLog === true\">\r\n      <section>\r\n        <lib-auth-login-log [userVid]=\"this.userVid\"></lib-auth-login-log>\r\n      </section>\r\n    </ng-container>\r\n  </div>\r\n</div>\r\n" }]
        }], ctorParameters: function () { return [{ type: i1.TranslationsLibService }, { type: i1.SessionLibService }]; }, propDecorators: { show2faConfig: [{
                type: Input
            }], show2faLog: [{
                type: Input
            }] } });

class App360AuthSharedModule {
}
App360AuthSharedModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
App360AuthSharedModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedModule, declarations: [AuthConfigComponent,
        Auth2faComponent,
        AuthLoginLogComponent], imports: [HttpClientModule,
        AppCommonsModule,
        UpperCasePipe,
        MatPaginatorModule,
        MatTableModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule,
        NgForOf,
        NgIf], exports: [AuthConfigComponent] });
App360AuthSharedModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedModule, imports: [HttpClientModule,
        AppCommonsModule,
        MatPaginatorModule,
        MatTableModule,
        MatInputModule,
        MatSelectModule,
        ReactiveFormsModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: App360AuthSharedModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        AuthConfigComponent,
                        Auth2faComponent,
                        AuthLoginLogComponent,
                    ],
                    imports: [
                        HttpClientModule,
                        AppCommonsModule,
                        UpperCasePipe,
                        MatPaginatorModule,
                        MatTableModule,
                        MatInputModule,
                        MatSelectModule,
                        ReactiveFormsModule,
                        NgForOf,
                        NgIf
                    ],
                    providers: [],
                    exports: [
                        AuthConfigComponent,
                    ]
                }]
        }] });

class Auth2faConfirmationComponent {
    constructor(translationsLib, route, helpersLib, authSharedService, router, sessionLib) {
        this.translationsLib = translationsLib;
        this.route = route;
        this.helpersLib = helpersLib;
        this.authSharedService = authSharedService;
        this.router = router;
        this.sessionLib = sessionLib;
        this.ready = false;
        this.showResend = false;
        this.sessionVid = null;
        this.userVid = null;
        this.fb = new FormBuilder();
        this.auth2faResendConfirmationCode = this.fb.group({
            email: [
                '',
                [
                    Validators.required,
                    Validators.pattern('^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,4}$'),
                ],
            ],
        });
    }
    ngOnInit() {
        this.route.queryParams.subscribe(({ session_vid, user_vid }) => {
            this.sessionVid = session_vid || null;
            this.userVid = user_vid || null;
            if (!this.sessionVid || !this.userVid) {
                Swal.fire({
                    icon: 'error',
                    title: this.translationsLib.get('error'),
                    text: this.translationsLib.get('fill_in_all_inputs_alert'),
                    confirmButtonColor: '#224261',
                }).then(() => {
                    window.location.href = '/';
                });
            }
            else {
                this.ready = true;
            }
        });
        this.helpersLib.setTitle('', this.translationsLib.get('auth_register_title'), '2FA');
    }
    confirmCode($event) {
        if (String($event).length !== 6) {
            return false;
        }
        this.authSharedService
            .confirm2fa({
            user_vid: this.userVid,
            confirmation_code: $event,
            session_vid: this.sessionVid,
        })
            .subscribe((authResponse) => {
            this.authSharedService.doLogin(authResponse).subscribe(() => {
                if (authResponse.next_action === 'auth_success_redirect_to_home') {
                    if (this.sessionLib.getUserType() === UserType.backofficeUser ||
                        this.sessionLib.getUserType() ===
                            UserType.backofficeSuperAdmin ||
                        this.sessionLib.getUserType() ===
                            UserType.backofficeSuperAdminDeveloper) {
                        location.replace('bo-home');
                    }
                    else if (this.sessionLib.getUserType() ===
                        UserType.backofficeFinancialAdmin) {
                        location.replace('bo-subscriptions');
                    }
                    else {
                        const home = String(this.sessionLib.getHome());
                        location.replace(home);
                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: this.translationsLib.get('error'),
                        text: 'Unexpected backend error :(',
                        confirmButtonColor: '#224261',
                    }).then();
                }
            });
        }, () => {
            Swal.fire({
                icon: 'error',
                title: this.translationsLib.get('error'),
                text: this.translationsLib.get('auth_registration_code_error'),
                confirmButtonColor: '#224261',
            }).then();
        });
    }
    resendCode() {
        this.codeInput.reset();
        this.authSharedService
            .resend2fa(this.auth2faResendConfirmationCode.value.email)
            .subscribe((authResponse) => {
            if (authResponse.next_action === 'auth_2fa_redirect_to_code') {
                Swal.fire({
                    icon: 'success',
                    title: this.translationsLib.get('success'),
                    text: this.translationsLib.get('auth_forgotten_enter_code_text'),
                    confirmButtonColor: '#224261',
                }).then(() => {
                    this.showResend = false;
                });
            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: this.translationsLib.get('error'),
                    text: this.translationsLib.get('auth_forgotten_error'),
                    confirmButtonColor: '#224261',
                }).then();
            }
        }, () => {
            Swal.fire({
                icon: 'error',
                title: this.translationsLib.get('error'),
                text: this.translationsLib.get('auth_forgotten_error'),
                confirmButtonColor: '#224261',
            }).then();
        });
    }
    redirectLogin() {
        this.router.navigate(['/login']).then();
    }
}
Auth2faConfirmationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: Auth2faConfirmationComponent, deps: [{ token: i1.TranslationsLibService }, { token: i2.ActivatedRoute }, { token: i1.HelpersLibService }, { token: App360AuthSharedService }, { token: i2.Router }, { token: i1.SessionLibService }], target: i0.ɵɵFactoryTarget.Component });
Auth2faConfirmationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.3.0", type: Auth2faConfirmationComponent, isStandalone: true, selector: "lib-register-confirmation", viewQueries: [{ propertyName: "codeInput", first: true, predicate: ["codeInput"], descendants: true }], ngImport: i0, template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n<div class=\"component-2fa-confirmation row justify-content-center\" *ngIf=\"ready === true\">\r\n  <div class=\"col-12 col-md-8 col-lg-6 col-xl-4 px-lg-6 my-5 align-self-center\">\r\n    <div id=\"login-loader\">\r\n      <div class=\"spinner-container\">\r\n        <div class=\"spinner-logo text-center\">\r\n          <img src=\"../../assets/img/ucrop.svg\" alt=\"LOGO\"  style=\"max-width: 200px\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section>\r\n      <h2 class=\"text-center mb-3\">\r\n        {{ 'auth_2fa_pending_code_title' | translation}}\r\n      </h2>\r\n\r\n      <!-- Subheading -->\r\n      <p class=\"text-muted text-center mb-5\">\r\n        {{ 'auth_2fa_pending_code_subtitle' | translation }}\r\n      </p>\r\n    </section>\r\n\r\n    <code-input id=\"codeInput\"\r\n                #codeInput\r\n                inputType=\"text\"\r\n                [isCodeHidden]=\"false\"\r\n                [codeLength]=\"6\"\r\n                (codeChanged)=\"confirmCode($event)\" #code>\r\n    </code-input>\r\n\r\n    <div class=\"text-center mt-4\">\r\n      <span class=\"text-muted text-center\" *ngIf=\"showResend === false\">\r\n        <a style=\"cursor: pointer; color:#3d6493\" (click)=\"showResend = true\">\r\n          {{ 'auth_forgotten_request_new' | translation }}\r\n        </a>\r\n      </span>\r\n      <form [formGroup]=\"auth2faResendConfirmationCode\" (submit)=\"resendCode()\" *ngIf=\"showResend === true\">\r\n        <div class=\"input-group\">\r\n          <input type=\"email\" class=\"form-control\" placeholder=\"{{ 'auth_email' | translation }}\" formControlName=\"email\">\r\n          <button type=\"submit\" class=\"btn btn-primary\"  [disabled]=\"auth2faResendConfirmationCode.invalid\">\r\n            {{ 'auth_resend_mail' | translation }}\r\n          </button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n    <div class=\"text-center mt-4\">\r\n      <span class=\"text-muted text-center\">\r\n        {{ 'auth_login_go_to_main_screen' | translation }}\r\n        <a style=\"cursor: pointer; color:#3d6493\" (click)=\"redirectLogin()\">\r\n          {{ 'auth_login_sign_up_text' | translation }}\r\n        </a>\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n  <div class=\"col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block\">\r\n    <!-- Image -->\r\n    <div class=\"bg-cover h-100 min-vh-100 mt-n1 me-n3\" style=\"background-image: url(assets/img/covers/Cover_login.jpg);\"></div>\r\n  </div>\r\n</div>\r\n", styles: ["@media (min-width: 991px){.component-2fa-confirmation code-input{margin:0 auto;font-size:18px;font-weight:700;width:250px;display:flex}}.component-2fa-confirmation .form-control{border:1px solid #c7c7c7;border-right:0;border-bottom-right-radius:0!important;border-top-right-radius:0!important;background:white!important}\n"], dependencies: [{ kind: "ngmodule", type: AppCommonsModule }, { kind: "component", type: i1.LoaderComponent, selector: "lib-loader" }, { kind: "pipe", type: i1.TranslationPipe, name: "translation" }, { kind: "directive", type: NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: CodeInputModule }, { kind: "component", type: i4$2.CodeInputComponent, selector: "code-input", inputs: ["isNonDigitsCode", "codeLength", "inputType", "initialFocusField", "isCharsCode", "isCodeHidden", "isPrevFocusableAfterClearing", "isFocusingOnLastByClickIfFilled", "code", "disabled", "autocapitalize"], outputs: ["codeChanged", "codeCompleted"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "directive", type: i5$1.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { kind: "directive", type: i5$1.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i5$1.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i5$1.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { kind: "directive", type: i5$1.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { kind: "directive", type: i5$1.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.3.0", ngImport: i0, type: Auth2faConfirmationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'lib-register-confirmation', standalone: true, imports: [
                        AppCommonsModule,
                        NgIf,
                        CodeInputModule,
                        ReactiveFormsModule
                    ], template: "<lib-loader *ngIf=\"ready === false\"></lib-loader>\r\n<div class=\"component-2fa-confirmation row justify-content-center\" *ngIf=\"ready === true\">\r\n  <div class=\"col-12 col-md-8 col-lg-6 col-xl-4 px-lg-6 my-5 align-self-center\">\r\n    <div id=\"login-loader\">\r\n      <div class=\"spinner-container\">\r\n        <div class=\"spinner-logo text-center\">\r\n          <img src=\"../../assets/img/ucrop.svg\" alt=\"LOGO\"  style=\"max-width: 200px\">\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <section>\r\n      <h2 class=\"text-center mb-3\">\r\n        {{ 'auth_2fa_pending_code_title' | translation}}\r\n      </h2>\r\n\r\n      <!-- Subheading -->\r\n      <p class=\"text-muted text-center mb-5\">\r\n        {{ 'auth_2fa_pending_code_subtitle' | translation }}\r\n      </p>\r\n    </section>\r\n\r\n    <code-input id=\"codeInput\"\r\n                #codeInput\r\n                inputType=\"text\"\r\n                [isCodeHidden]=\"false\"\r\n                [codeLength]=\"6\"\r\n                (codeChanged)=\"confirmCode($event)\" #code>\r\n    </code-input>\r\n\r\n    <div class=\"text-center mt-4\">\r\n      <span class=\"text-muted text-center\" *ngIf=\"showResend === false\">\r\n        <a style=\"cursor: pointer; color:#3d6493\" (click)=\"showResend = true\">\r\n          {{ 'auth_forgotten_request_new' | translation }}\r\n        </a>\r\n      </span>\r\n      <form [formGroup]=\"auth2faResendConfirmationCode\" (submit)=\"resendCode()\" *ngIf=\"showResend === true\">\r\n        <div class=\"input-group\">\r\n          <input type=\"email\" class=\"form-control\" placeholder=\"{{ 'auth_email' | translation }}\" formControlName=\"email\">\r\n          <button type=\"submit\" class=\"btn btn-primary\"  [disabled]=\"auth2faResendConfirmationCode.invalid\">\r\n            {{ 'auth_resend_mail' | translation }}\r\n          </button>\r\n        </div>\r\n      </form>\r\n    </div>\r\n\r\n    <div class=\"text-center mt-4\">\r\n      <span class=\"text-muted text-center\">\r\n        {{ 'auth_login_go_to_main_screen' | translation }}\r\n        <a style=\"cursor: pointer; color:#3d6493\" (click)=\"redirectLogin()\">\r\n          {{ 'auth_login_sign_up_text' | translation }}\r\n        </a>\r\n      </span>\r\n    </div>\r\n\r\n  </div>\r\n  <div class=\"col-12 col-md-7 col-lg-6 col-xl-8 d-none d-lg-block\">\r\n    <!-- Image -->\r\n    <div class=\"bg-cover h-100 min-vh-100 mt-n1 me-n3\" style=\"background-image: url(assets/img/covers/Cover_login.jpg);\"></div>\r\n  </div>\r\n</div>\r\n", styles: ["@media (min-width: 991px){.component-2fa-confirmation code-input{margin:0 auto;font-size:18px;font-weight:700;width:250px;display:flex}}.component-2fa-confirmation .form-control{border:1px solid #c7c7c7;border-right:0;border-bottom-right-radius:0!important;border-top-right-radius:0!important;background:white!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslationsLibService }, { type: i2.ActivatedRoute }, { type: i1.HelpersLibService }, { type: App360AuthSharedService }, { type: i2.Router }, { type: i1.SessionLibService }]; }, propDecorators: { codeInput: [{
                type: ViewChild,
                args: ['codeInput']
            }] } });

/*
 * Public API Surface of app360-auth-shared
 */

/**
 * Generated bundle index. Do not edit.
 */

export { App360AuthSharedModule, App360AuthSharedService, Auth2faConfirmationComponent, AuthConfigComponent, JwtInterceptor };
